'use strict';

import { view } from '@/functions';

const prefix = '/refunds';

export default [
    {
        path: prefix,
        name: 'refunds',
        meta: {
            title: 'Refunds',
            scopes: ['read_refunds', 'write_refunds']
        },
        component: () => view('refunds/index'),
    },
    {
        path: `${prefix}/info`,
        name: 'refunds-info',
        meta: {
            title: 'Refunds',
            scopes: ['read_refunds', 'write_refunds']
        },
        component: () => view('refunds/info'),
    }
]

